var map = {
	"./accountSettings.svg": 7114,
	"./add.svg": 1645,
	"./advertisements.svg": 5920,
	"./advertisements_active.svg": 4040,
	"./arrow_left.svg": 4651,
	"./arrow_right.svg": 8266,
	"./arrow_right_background.svg": 7831,
	"./arrow_right_blue.svg": 1736,
	"./back_black.svg": 5788,
	"./bell.svg": 3643,
	"./calendar.svg": 1421,
	"./caret_down.svg": 4951,
	"./caret_down_black.svg": 3534,
	"./caret_left.svg": 9737,
	"./caret_right.svg": 2991,
	"./check.svg": 4687,
	"./close.svg": 2479,
	"./cluster.svg": 394,
	"./dashboard.svg": 8554,
	"./delete.svg": 2474,
	"./desc.svg": 1538,
	"./download.svg": 7910,
	"./edit.svg": 9911,
	"./edit_new.svg": 497,
	"./editions.svg": 7426,
	"./editions_active.svg": 3893,
	"./error.svg": 7211,
	"./error_red.svg": 341,
	"./header_success.svg": 6814,
	"./home.svg": 1164,
	"./home_active.svg": 344,
	"./houses.svg": 6390,
	"./id.svg": 6250,
	"./image.svg": 4160,
	"./info.svg": 9932,
	"./info_white.svg": 8749,
	"./knowledge.svg": 4125,
	"./logo.svg": 1204,
	"./logout.svg": 230,
	"./logout_active.svg": 1329,
	"./maximize.svg": 7878,
	"./menu_burger.svg": 8665,
	"./message.svg": 5686,
	"./moon.svg": 6799,
	"./my_advertisements.svg": 587,
	"./my_advertisements_active.svg": 5132,
	"./myaccount.svg": 8706,
	"./myaccount_active.svg": 7232,
	"./netplan.svg": 9177,
	"./old_editions.svg": 6853,
	"./old_editions_active.svg": 1190,
	"./password.svg": 4134,
	"./print.svg": 5857,
	"./read.svg": 1766,
	"./rename.svg": 9696,
	"./search.svg": 2661,
	"./selectTriangle.svg": 5681,
	"./settings.svg": 3047,
	"./settings_active.svg": 3982,
	"./sort_dots.svg": 9067,
	"./statistics.svg": 9305,
	"./success.svg": 735,
	"./sun.svg": 5938,
	"./text.svg": 5987,
	"./ticket.svg": 7870,
	"./tickets.svg": 4549,
	"./times.svg": 2565,
	"./user.svg": 2327,
	"./users.svg": 8178,
	"./users_active.svg": 5871,
	"./warning.svg": 5561
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2420;